<template>
  <div class="user_container">
    <div class="container_top">
      <div class="field">
        <div class="field_label">姓名</div>
        <div class="field_value">{{name}}</div>
      </div>
      <div class="field_menu"></div>
      <div class="field">
        <div class="field_label">日期</div>
        <div class="field_value">{{startDate}} 到 {{endDate}}</div>
      </div>
      <div class="field_menu"></div>
      <div class="field">
        <div class="field_label">合计</div>
        <div class="field_value">{{list.length}}条</div>
      </div>
    </div>
    <div class="container_con">
      <div v-for="item in list" :key="item.id" class="box_field">
        <div class="field">
          <div class="field_label">客户姓名：</div>
          <div class="field_value">匿名</div>
        </div>
        <div class="field">
          <div class="field_label">评价时间：</div>
          <div class="field_value">{{ item.createTime }}</div>
        </div>
        <div class="field">
          <div class="field_label">用车时间：</div>
          <div class="field_value">{{ item.departTime + " — " + item.comebackTime }}</div>
        </div>
        <div class="field">
          <div class="field_label">客户评分：</div>
          <div class="field_value">{{ item.score }}分</div>
        </div>

        <div class="field1">
          <div class="field_label">评价信息标签：</div>
          <div class="field_value check">
            <span v-for="i in item.label" :key="i">{{ i }}</span>
          </div>
        </div>
        <div class="field1">
          <div class="field_label">客户评价补充：</div>
          <div class="field_value" :class="{ message: item.remarks }">
            {{ item.remarks }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiCar from "@/apis/car";
export default {
  name: "detail",
  props: {},
  components: {},
  data() {
    return {
      list: [],
      driverCode: "",
      startDate: "",
      endDate: "",
      name:'',
      zoneId:''
    };
  },
  created() {},
  mounted() {
    const { driverCode, startDate, endDate,name,zoneId } = this.$route.query;
    this.driverCode = driverCode;
    this.startDate = startDate;
    this.endDate = endDate;
    this.name = name;
    this.zoneId = zoneId;
    this.getList();
  },
  methods: {
    //获取司机评价详情
    getList() {
      apiCar
        .weekCommentCountByLeaderDetail({
          startDate: this.startDate,
          endDate: this.endDate,
          driverCode: this.driverCode,
          zoneId:this.zoneId
        })
        .then((data) => {
          console.log(data, "data");
          const res = data.data;
          res.forEach((item) => {
            item.label = item.label ? item.label.split(",") : [];
          });
          this.list = [...res];
          console.log(this.list, "");
        });
    },
    //返回上一页
    toUrl() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  min-height: 100vh;
  //   padding: 30px;
  margin: auto;
  font-size: 1vh;
  font-size: 26px;
  //   position: relative;
  overflow: hidden;
  .container_top {
    background: #fff;
    // height: 100px;
    font-size: 32px;
    padding: 30px;
    .field {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .field_menu {
      width: 100%;
      height: 1px;
      background: rgba(241, 241, 241, 1);
      margin: 30px 0;
    }
    .field_label {
      color: rgba(102, 102, 102, 1);
      font-size: 28px;
    }
    .field_value {
      color: #000;
      font-size: 30px;
    }
  }
  .container_con {
    padding: 30px;
    .box_field {
      padding: 30px;
      border-radius: 15px;
      background: #fff;
      margin-bottom: 25px;
    }
    .field {
      display: flex;
      align-items: center;
      margin-bottom: 25px;
      .field_label {
        color: rgba(102, 102, 102, 1);
        font-size: 30px;
        min-width: 160px;
      }
      .field_value {
        color: #000;
        font-size: 30px;
      }
    }
    .field1 {
      // margin-bottom: 25px;
      .field_label {
        color: rgba(102, 102, 102, 1);
        font-size: 30px;
      }
      .field_value {
        color: #000;
        font-size: 30px;
      }
      .check {
        margin-top: 25px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        span {
          color: rgba(51, 143, 108, 1);
          background: rgba(78, 162, 124, 0.1);
          border-radius: 10px;
          margin-right: 20px;
          padding: 20px 30px;
          margin-bottom: 25px;
        }
      }
      .message {
        background: rgba(247, 249, 250, 1);
        padding: 25px;
        margin-top: 25px;
      }
    }
  }
}
</style>
